import { BroadcastChannel } from 'broadcast-channel';
/**
 * Singleton instance that manages multiple broadcast channels
 */
class AlucioChannel {
    commonChannels = {
        PDF_CHANNEL: 'PDF_CHANNEL',
        PRESENTATION_CHANNEL: 'PRESENTATION_CHANNEL',
    };
    lastRequestedAt = {};
    channels = {};
    get(name) {
        if (!this.channels[name]) {
            this.channels[name] = new BroadcastChannel(name);
        }
        this.lastRequestedAt[name] = new Date();
        return this.channels[name];
    }
    async remove(name) {
        const removeRequestedAt = new Date();
        const differenceInSeconds = (removeRequestedAt.getTime() - this.lastRequestedAt[name].getTime()) / 1000;
        if (!this.channels[name]) {
            throw new Error(`Channel ${name} does not exist`);
        }
        // NOTE: THE IDEA BEHIND THIS IS TO AVOID RACE CONDITIONS BY REMOVING A CHANNEL THAT'S ABOUT TO BE USED //
        if (differenceInSeconds > 1) {
            await this.channels[name].close();
            delete this.channels[name];
        }
    }
}
export default new AlucioChannel();
//# sourceMappingURL=broadcastChannel.web.js.map